<template>
    <b-row no-gutters align-h="between" >
            <b-col cols="5" style="margin-left: 10px;" v-if="multipleChart">
                <small v-show="weakestDataUnit != null" class="text-danger"> {{ $t(weakestDataUnit+"-convert") }} </small> 
                <horizontal-bar-chart :chart-data="barChartWeakest.data" :options="barChartWeakest.options" :chart-id="barChartWeakest.id"/>
            </b-col>
            <b-col :cols="multipleChart ? 5 : 11" style="margin-right: 10px;">
                <small v-show="bestDataUnit != null" class="text-danger">  {{ $t(bestDataUnit+"-convert") }} </small> 
                <horizontal-bar-chart :chart-data="barChartBest.data" :options="barChartBest.options" :chart-id="barChartBest.id"/>
            </b-col>
    </b-row>
</template>

<script>
import HorizontalBarChart from '../../../../components/charts/HorizontalBarChart';
import globalFilters from '../../../../filters';
import _ from 'lodash';
import uuidV4 from 'uuid/v4';

export default {
    name: 'PerformanceComparing',
    components: {
        HorizontalBarChart
    },
    props: {
        comparingData: {
            type: Array,
            default() {
                return [];
            }
        },
        type: {
            type: String,
            default() {
                return 'emission';
            }
        },
        selectedSiteGroupId: {
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            barChartBest: {
                id: uuidV4(),
                data: {
                    labels: [],
                    datasets: [{backgroundColor: '#35f826', data: []}],
                    generateUnit: () => {
                        return this.calculatedUnit;
                    },
                    getLocale: () => this.locale
                },
                options: {
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    animation: {
                        duration: 500,
                        animateScale: true,
                        easing: 'easeOutQuint',
                        onComplete: function() {
                            let chartInstance = this.chart;
                            let ctx = chartInstance.ctx;
                            ctx.textAlign = 'center';
                            ctx.fillStyle = 'rgba(49, 57, 54, 1)';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach((dataset, i) => {
                                let meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach((bar, index) => {
                                    let data = dataset.data[index];
                                    ctx.fillText(
                                        data
                                            ? globalFilters.parseNumber(
                                                  data,
                                                  'number',
                                                  this.data.getLocale()
                                              )
                                            : '',
                                        bar._model.x + 10,
                                        bar._model.y + 6
                                    );
                                });
                            });
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    beginAtZero: true,
                                    stepSize: 5,
                                    max: 50
                                }
                            }
                        ],
                        yAxes: [
                            {
                                maxBarThickness: 25,
                                display: true,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    autoSkip: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                let label = data.datasets[tooltipItem.datasetIndex].label || '';
                                if (label) {
                                    label += ': ';
                                }

                                return (
                                    label +
                                    globalFilters.parseNumber(
                                        Number(
                                            data.datasets[tooltipItem.datasetIndex].data[
                                                tooltipItem.index
                                            ].toFixed(2)
                                        ),
                                        'number',
                                        this.locale
                                    ) +
                                    (this.bestDataUnit ? ` `+ this.bestDataUnit : ` ${this.calculatedUnit}`)
                                );
                            }
                        }
                    }
                }
            },
            barChartWeakest: {
                id: uuidV4(),
                data: {
                    labels: [],
                    datasets: [{backgroundColor: '#f87979', data: []}],
                    generateUnit: () => {
                        return this.calculatedUnit;
                    },
                    getLocale: () => this.locale
                },
                options: {
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    animation: {
                        duration: 500,
                        animateScale: true,
                        easing: 'easeOutQuint',
                        onComplete: function() {
                            let chartInstance = this.chart;
                            let ctx = chartInstance.ctx;
                            ctx.textAlign = 'center';
                            ctx.fillStyle = 'rgba(49, 57, 54, 1)';
                            ctx.textBaseline = 'bottom';
                            this.data.datasets.forEach((dataset, i) => {
                                let meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach((bar, index) => {
                                    let data =
                                        dataset.data[index]; /* + ` ${this.data.generateUnit()}`;*/
                                    ctx.fillText(
                                        data
                                            ? globalFilters.parseNumber(
                                                  data,
                                                  'number',
                                                  this.data.getLocale()
                                              )
                                            : '',
                                        bar._model.x + 16,
                                        bar._model.y + 6
                                    );
                                });
                            });
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    beginAtZero: true,
                                    stepSize: 5,
                                    max: 50
                                }
                            }
                        ],
                        yAxes: [
                            {
                                maxBarThickness: 25,
                                display: true,
                                scaleFontSize: 15,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    fontSize: 10,
                                    autoSkip: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                let label = data.datasets[tooltipItem.datasetIndex].label || '';
                                if (label) {
                                    label += ': ';
                                }

                                return (
                                    label +
                                    globalFilters.parseNumber(
                                        data.datasets[tooltipItem.datasetIndex].data[
                                            tooltipItem.index
                                        ],
                                        'number',
                                        this.locale
                                    ) +
                                    (this.weakestDataUnit ? ` `+ this.weakestDataUnit : ` ${this.calculatedUnit}`)
                                );
                            }
                        }
                    }
                }
            },
            multipleChart: false,

            bestDataUnit: null,
            weakestDataUnit: null,
            unitConverter: {
                "TJ":1000,
                "PJ":1000000,
                "GWh":1000,
                "TWh":1000000
            }
        };
    },
    methods: {
        configureCharts(data) {
            if (data.length > 5) {
                this.multipleChart = true;
                let best = _.take(data, 5);
                let weakest = _.take(data.reverse(), 5);

                this.setWeakestUnitToFit(_.first(weakest));
                this.setBestUnitToFit(_.first(best));
                
                
                this.configureChart(weakest, 'barChartWeakest', this.weakestDataUnit);
                this.configureChart(best, 'barChartBest', this.bestDataUnit);
            } else {
                this.multipleChart = false;
                this.configureChart(data, 'barChartBest', this.bestDataUnit);
            }
        },
        setWeakestUnitToFit(data){
            let cValue = _.get(data,"value");
            switch(_.get(data,"unit")){
                case "GJ":
                    if(cValue >= 1000000000){
                        this.weakestDataUnit = "PJ";
                    }
                    else if(cValue >= 1000000){
                        this.weakestDataUnit = "TJ";
                    }
                    break;
                case "MWh":
                    if(cValue >= 1000000000){
                        this.weakestDataUnit = "TWh";
                    }
                    else if(cValue >= 1000000){
                        this.weakestDataUnit = "GWh";
                    }
                    break;
                default:
                    this.weakestDataUnit = null;
                    break;
            }

            if(this.weakestDataUnit){
                this.barChartWeakest.data.generateUnit = this.weakestDataUnit;
            }

        },
        setBestUnitToFit(data){
            let cValue = _.get(data,"value");
            switch(_.get(data,"unit")){
                case "GJ":
                    if(cValue >= 1000000000){
                        this.bestDataUnit = "PJ";
                    }
                    else if(cValue >= 1000000){
                        this.bestDataUnit = "TJ";
                    }
                    break;
                case "MWh":
                    if(cValue >= 1000000000){
                        this.bestDataUnit = "TWh";
                    }
                    else if(cValue >= 1000000){
                        this.bestDataUnit = "GWh";
                    }
                    break;
                default:
                    this.bestDataUnit = null;
                    break;
            }

            if(this.weakestDataUnit){
                this.barChartBest.data.generateUnit = this.bestDataUnit;
            }
        },
        configureChart(data, type, cUnit) {
            this[type].data.labels = [];
            this[type].data.datasets[0].data = [];
            data.forEach(element => {
                element.value = element.value ? (cUnit ? element.value/this.unitConverter[cUnit] : element.value) : 0;
                let foundName = _.find(this.sites, {id: element.siteId}).originalName;
                this[type].data.labels.push(foundName);
                this[type].data.datasets[0].data.push(Number(element.value.toFixed(0)));
                if(cUnit){
                    element.unit = cUnit;
                }
            });
            let max = _.max(this[type].data.datasets[0].data);
            this[type].options.scales.xAxes[0].ticks.max = max + max * 0.15;
            this.$eventHub.$emit(this[type].id);
        },
        filterData(data) {
            if (this.type === 'intensity') {
                let [emissions, staffs] = data;
                data = _.reduce(
                    emissions,
                    (newData, emission) => {
                        const found = _.find(staffs, {id: emission.siteId});
                        if (found && found.count !== 0) {
                            newData.push({
                                siteId: emission.siteId,
                                value: emission.value / found.count
                            });
                        }
                        return newData;
                    },
                    []
                );
                data = _.orderBy(data, 'value', 'asc');
            }
            data = _.filter(data, datum => {
                if (Number(datum.value.toFixed(0)) !== 0) {
                    return datum;
                }
            });
            return Promise.resolve(data);
        },
        totalStaffCount(site) {
            let property = this.getLastFilledProperty(site, 'staffCount');
            return property && property.staffCount ? property.staffCount : 0;
        },
        processPerformanceComparing(data) {
            this.filterData(data).then(this.configureCharts);
        }
    },
    watch: {
        comparingData(data) {
            this.processPerformanceComparing(data);
        },
        selectedSiteGroupId() {
            this.processPerformanceComparing(this.comparingData);
        }
    },
    computed: {
        calculatedUnit() {
            if (this.type === 'intensity') {
                return this.$t('tonssquaremeter');
            } else if (this.type === 'emission') {
                return this.$t('tons');
            } else if (this.type === 'consumption') {
                return this.$t('mwh');
            } else {
                return '';
            }
        }
    },
    mounted() {
        this.processPerformanceComparing(this.comparingData);
    }
};
</script>

<style scoped>
</style>

<i18n>
    {
        "tr": {
            "tonssquaremeter": "tonCO2e / m²",
            "tons": "tonCO2e",
            "mwh": "MWh",
            "TJ-convert": "Since the values were too large, the analysis unit was changed to TJ.",
            "PJ-convert": "Since the values were too large, the analysis unit was changed to PJ.",
            "GWh-convert": "Since the values were too large, the analysis unit was changed to GWh.",
            "TWh-convert": "Since the values were too large, the analysis unit was changed to TWh."
        },
        "en": {
            "tonssquaremeter": "mtCO2e / m²",
            "tons": "mtCO2e",
            "mwh": "MWh",
            "TJ-convert": "Değerler çok büyük olduğundan analiz birimi TJ olarak değiştirilmiştir.",
            "PJ-convert": "Değerler çok büyük olduğundan analiz birimi PJ olarak değiştirilmiştir.",
            "GWh-convert": "Değerler çok büyük olduğundan analiz birimi GWh olarak değiştirilmiştir.",
            "TWh-convert": "Değerler çok büyük olduğundan analiz birimi TWh olarak değiştirilmiştir."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Analysis/Tabs/components/PerformanceComparing.vue